import { Reducer } from "../../lib/redux";
import { DriverSeatUserActions } from "./actions";
import { DriverSeatUserActionTypes } from "./types";

export const defaultDriverSeatUser: DeepReadonly<string> = "";

export const driverSeatUser: Reducer<DeepReadonly<string>, DriverSeatUserActions> = (state = defaultDriverSeatUser, action) => {
    switch (action.type) {
        case DriverSeatUserActionTypes.SET_DRIVER_SEAT_USER: {
            return action.payload;
        }
        case DriverSeatUserActionTypes.CLEAR_DRIVER_SEAT_USER: {
            return "";
        }
        default:
            return state;
    }
};